import React from "react";
import FloatingWhatsapp from "../FloatingWhatsapp";
import Footer from "../../Footer";
import NewNavBar from "../../LandingPage/NewNavBar";

import style from "./styles.module.scss";

interface Props {
  title?: string;
}

export default function Layout({
  children,
  title,
}: React.PropsWithChildren<Props>) {
  document.title = title ? `Portal da PGM - ${title}` : "Portal da PGM";

  return (
    <div className={style.layout}>
      <NewNavBar />
      <main className={style.layoutContent}>{children}</main>
      <Footer />
      <FloatingWhatsapp />
    </div>
  );
}
